import { render, staticRenderFns } from "./CompanyIndexSearchResult.vue?vue&type=template&id=5a91fd28&scoped=true&"
import script from "../../services/company/company-index-search-result.js?vue&type=script&lang=js&"
export * from "../../services/company/company-index-search-result.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/index.css?vue&type=style&index=0&id=5a91fd28&scoped=true&lang=css&"
import style1 from "@/assets/css/company.css?vue&type=style&index=1&id=5a91fd28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a91fd28",
  null
  
)

export default component.exports